<script setup lang="ts">
import { ref } from 'vue';
import IconX from '@icons/ph_x.svg';
import { useDataTableStore } from '../../../_00_elements/tools/store/pinia/useDataTableStore.ts';
import { trans } from '../../../_00_elements/translation';
import Icon from '../../../_01_atoms/components/Icon.vue';

const { addFilter } = useDataTableStore();
const invoiceNumber = ref<string>();
const debounceTimeout = ref<ReturnType<typeof setTimeout> | null>(null);

const addInvoiceFilter = (): void => {
  addFilter('invoiceNumber', invoiceNumber.value);
};

const handleFilterChange = (): void => {
  if (debounceTimeout.value) {
    clearTimeout(debounceTimeout.value);
  }

  debounceTimeout.value = setTimeout(addInvoiceFilter, 300);
};

const clear = (): void => {
  invoiceNumber.value = undefined;
  addInvoiceFilter();
};
</script>

<template>
  <form class="invoice-filters" @submit.prevent.stop>
    <div class="input-text input-text--filter input-text--group">
      <input v-model="invoiceNumber" type="search" :placeholder="trans('gestion.invoice.filter.invoice_number')" @input="handleFilterChange">
      <button type="reset" class="btn-clear" @click="clear">
        <Icon :svg="IconX" />
      </button>
    </div>
  </form>
</template>
